import React from "react";

export default function Solution() {
  const solutions = [
    {
      title: "Tokenized Smart Contracts",
      description: "Automate eligibility, funding, and redemption using code-based benefit rules."
    },
    {
      title: "AI Onboarding & Support",
      description: "Conversational agents interpret plan docs and guide employees 24/7."
    },
    {
      title: "BUCA Integration",
      description: "Keep core health benefits with trusted PPO networks (BCBS, UHC, Aetna, etc.)"
    },
    {
      title: "HRIS + Census Sync",
      description: "API connections to Workday, ADP, UKG keep eligibility synced."
    },
    {
      title: "PBM & Stop-Loss Optimization",
      description: "Ingest claims + census data for smarter insurance decisions."
    },
    {
      title: "Compliance-First Architecture",
      description: "Built-in ERISA, HIPAA, ACA alignment with auditability."
    }
  ];

  return (
    <section className="bg-gray-50 py-20 px-6" id="solution">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Meet BenefitChain
        </h2>
        
        <p className="text-gray-600 text-lg max-w-3xl mx-auto mb-12">
          A blockchain-based benefits platform for self-insured employers — delivering transparent funding, predictive planning, and personalized engagement at scale.
        </p>

        <div className="grid md:grid-cols-3 gap-8 text-left">
          {solutions.map((solution, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold mb-2 text-gray-800">
                {solution.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {solution.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 